import React from "react";
import moment from "moment";
import { useStaffAppraisalsStore } from "../../../../config/stores";
import { Col, Row } from "antd";

const AppraisalSummary = () => {
  const staffAppraisalStore = useStaffAppraisalsStore();
  const { staffAppraisalDetails } = staffAppraisalStore;
  return (
    <div>
      <table className="table table-sm table-bordered">
        <tbody>
          <tr>
            <td className="fw-bold w-50">Date of Appraisal</td>
            <td>
              {moment(staffAppraisalDetails?.date_of_appraisal).format(
                "DD/MM/YYYY"
              )}
            </td>
          </tr>
          <tr>
            <td className="fw-bold w-50">Period</td>
            <td>
              {moment(staffAppraisalDetails?.start_date).format("DD/MM/YYYY")} -{" "}
              {moment(staffAppraisalDetails?.end_date).format("DD/MM/YYYY")}
            </td>
          </tr>
        </tbody>
      </table>
      <p className="my-1">
        <span className="fw-bold">Reason for Appraisal:</span>{" "}
        {staffAppraisalDetails?.reason_for_appraisal}
      </p>
      <Row gutter={4}>
        <Col span={12}>
          {" "}
          <table className="table my-2 table-bordered table-sm">
            <tbody>
              <tr>
                <td className="w-50 fw-bold">Name of Staff (Appraisee):</td>
                <td>
                  {staffAppraisalDetails?.user?.first_name}{" "}
                  {staffAppraisalDetails?.user?.other_names}
                </td>
              </tr>
              <tr>
                <td className="w-50 fw-bold">Position:</td>
                <td>{staffAppraisalDetails?.userRole?.role}</td>
              </tr>
              <tr>
                <td className="w-50 fw-bold">Main Program/Department:</td>
                <td>{staffAppraisalDetails?.user?.department}</td>
              </tr>
              <tr>
                <td className="w-50 fw-bold">Employee Card No:</td>
                <td>
                  {staffAppraisalDetails?.staffContract?.employee_card_no}
                </td>
              </tr>
              <tr>
                <td className="w-50 fw-bold">Date Joined Amani Initiative:</td>
                <td>
                  {moment(
                    staffAppraisalDetails?.staffContract?.date_of_joining
                  ).format("DD/MM/YYYY")}
                </td>
              </tr>
              <tr>
                <td className="w-50 fw-bold">Date started current Contract:</td>
                <td>
                  {moment(
                    staffAppraisalDetails?.staffContract?.start_date
                  ).format("DD/MM/YYYY")}
                </td>
              </tr>
            </tbody>
          </table>
        </Col>
        <Col span={12}>
          {" "}
          <table className="table my-2 table-bordered table-sm">
            <tbody>
              <tr>
                <td className="w-50 fw-bold">
                  Name of Supervisor (Appraiser):
                </td>
                <td>
                  {staffAppraisalDetails?.supervisor?.first_name}{" "}
                  {staffAppraisalDetails?.supervisor?.other_names}
                </td>
              </tr>
              <tr>
                <td className="w-50 fw-bold">Position:</td>
                <td>{staffAppraisalDetails?.supervisorRole?.role}</td>
              </tr>
              <tr>
                <td className="w-50 fw-bold">Main Program/Department:</td>
                <td>{staffAppraisalDetails?.supervisor?.department}</td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>
    </div>
  );
};

export default AppraisalSummary;
